import { apiFetch } from "./apiClient";

export const adminApi = {
  pendingApprovals: (token) => apiFetch("/api/approvals/pending", { method: "GET", token }),
  approve: (id, token) => apiFetch(`/api/approvals/${id}/approve`, { method: "POST", token }),
  reject: (id, reason, token) =>
    apiFetch(`/api/approvals/${id}/reject`, { method: "POST", body: { reason }, token }),
};
